import React from 'react';

export interface DevTool {
  name: string;
  component: React.ComponentType;
}

export const devTools: DevTool[] = [];

export function registerDevTool(tool: DevTool) {
  const idx = devTools.findIndex((t) => t.name === tool.name);
  if (idx !== -1) {
    devTools[idx] = tool;
  } else {
    devTools.push(tool);
  }
}
